<template>
  <div id="proposta_passo1">
   <el-row type="flex" >
      <el-col :span="24" style="text-align:right" >
        <el-button style="margin-top: 12px; text-align: left;"  type="primary" size="small" round plain @click="anterior" :disabled="disable_left"><i class="el-icon-d-arrow-left"></i> Anterior</el-button>
        <el-button style="margin-top: 12px;"  type="primary" plain round size="small" @click="next" :disabled="disable_right">Próximo <i class="el-icon-d-arrow-right"></i></el-button>
      </el-col>
    </el-row>      
    <el-row>
      <el-col :span="24" class="proposta_titulo proposta_centro ">
        <p>Passo 2 - Apresentação da Empresa</p>
      </el-col>
    </el-row>
    <el-form :model="ruleForm"  :rules="ruleForm" ref="ruleForm" >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo">
          <el-input v-model="ruleForm.titulo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo">
              <el-input v-model="ruleForm.subtitulo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>      
    <el-row>
      <el-col :span="24">      
       <el-form-item label="" prop="apresentacao">
         <vue-editor id="apresentacao" v-model="ruleForm.apresentacao" :editor-toolbar="customToolbar"></vue-editor>
      </el-form-item>
      </el-col>
    </el-row>
    </el-form>
    {{proposta_id}}
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
   components: {
    VueEditor,
  },
  props: {
  proposta_id: [Number]
},
   data() {
    return {
      customToolbar: [
      ["bold", "italic", "underline","strike"],
      [{ list: "ordered" }, { list: "bullet" }]
    ],      
       disable_left: false,
       disable_right: false,        
       ruleForm: {
         titulo:"",
         subtitulo:"",
         apresentacao: "",
       },
    };
   },
   mounted() {

      let dados = {
        pagina_pagina: "2",
      };
      axios
        .post(url + "/proposta/"+this.proposta_id, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
           if(resp.data['pagina'].length==1){
             this.ruleForm.titulo = resp.data['pagina'][0].titulo;
             this.ruleForm.subtitulo = resp.data['pagina'][0].subtitulo;
             this.ruleForm.apresentacao = resp.data['pagina'][0].texto;
           } else {
            for (let i=0;i<resp.data['pagina'].length;i++){
              switch(resp.data['pagina'][i].slug){
                case 'titulo': this.ruleForm.titulo = resp.data['pagina'][i].texto; break;
                case 'subtitulo': this.ruleForm.subtitulo = resp.data['pagina'][i].texto; break;
                case 'apresentacao': this.ruleForm.apresentacao = resp.data['pagina'][i].texto; break;
              }
            }
           }
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });             
   },
  
     methods: {
      next() {
      if(this.ruleForm.subtitulo == null){
        this.ruleForm.subtitulo = '';
      }  
      let dados = {
        proposta_id: this.proposta_id,
        proposta_projeto_id: this.$route.params.id,
        proposta_status: "R",
        pagina_paginaTipo: "A",
        pagina_pagina: "2",
        ///ordem dos dados = texto*ordem*slug*label*tipo //campos separados por * e mais campos por |
        pagina_dados: this.ruleForm.titulo+'*1*titulo*Titulo Apresentação*TA|'+this.ruleForm.subtitulo+'*2*subtitulo*Subtitulo*TA|'+this.ruleForm.apresentacao+'*1*apresentacao*APRESENTAÇÃO DA EMPRESA*A|',
      };
      axios
        .post(url + "/proposta/register/", dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          this.$notify({
            title: "Sucesso",
            message: "Registro salvo com Sucesso!",
            type: "success",
          });

          let prop;
          prop = resp.data["proposta"].id;
          let dado = {
            active: 3,
            proposta: prop,
          };
          this.$emit("button-click", dado);
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });        
      },
      anterior() {
        let dado = {
          'active':1,
          'proposta':this.proposta_id,
        };        
        this.$emit('button-click',dado);
      }      
    }
};
</script>

<style>
#proposta_passo1 #apresentacao  {
  height: 500px;
  width: 100%;
}
</style>

